var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnInit, ElementRef, Renderer2, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Store, Select, Actions, ofActionDispatched } from '@ngxs/store';
import { SetReady, SetGraph, SetEngineChapterInit, SynchronizeVisibleNodes, SetEngineChapter, ClickNode, FlyToNode, SynchronizeRenderableNodes } from '../../state/engine.actions';
import { EngineState } from '../../state/engine.state';
import { Observable, Subscription, fromEvent, BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { filter, takeUntil, bufferTime, debounceTime } from 'rxjs/operators';
import { EngineService, EngineEventsEnum } from '../../engine.service';
import { environment } from 'src/environments/environment';
import { CameraService } from '../../camera.service';
import { EngineVisibilityEnum } from '../../models/engine-visibility.enum';
import { ToolEnum } from 'src/app/engine/models/tool.enum';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { PaintService } from '../../paint.service';
import { SetCamera, MoveCamera } from '../../state/camera/engine.camera.actions';
import { CameraMotionModel } from '../../models/camera-motion.model';
import { EngineCameraState } from '../../state/camera/engine.camera.state';
import { AnimationService } from '../../animation.service';
import { BackgroundModel } from '../../models/background.model';
import { HoverNode } from '../../state/nodes/engine.nodes.actions';
import { EngineNodesState } from '../../state/nodes/engine.nodes.state';
import * as Hammer from 'hammerjs';
import * as _ from 'lodash';
var KeyboardCamera;
(function (KeyboardCamera) {
    KeyboardCamera[KeyboardCamera["Pan"] = 0.4] = "Pan";
    KeyboardCamera[KeyboardCamera["PanSlow"] = 0.04] = "PanSlow";
    KeyboardCamera[KeyboardCamera["Zoom"] = 5] = "Zoom";
    KeyboardCamera[KeyboardCamera["ZoomSlow"] = 1] = "ZoomSlow";
    KeyboardCamera[KeyboardCamera["Rotate"] = 0.3] = "Rotate";
    KeyboardCamera[KeyboardCamera["RotateSlow"] = 0.03] = "RotateSlow";
})(KeyboardCamera || (KeyboardCamera = {}));
var MouseCamera;
(function (MouseCamera) {
    MouseCamera[MouseCamera["Rotate"] = 6] = "Rotate";
    MouseCamera[MouseCamera["Pan"] = 1.75] = "Pan";
    MouseCamera[MouseCamera["Zoom"] = 2] = "Zoom";
})(MouseCamera || (MouseCamera = {}));
var TouchCamera;
(function (TouchCamera) {
    TouchCamera[TouchCamera["Zoom"] = -12] = "Zoom";
})(TouchCamera || (TouchCamera = {}));
var CursorClasses;
(function (CursorClasses) {
    CursorClasses["Hide"] = "engine--cursor-hide";
    CursorClasses["Label"] = "engine--cursor-label";
    CursorClasses["Paint"] = "engine--cursor-paint";
    CursorClasses["Crosshair"] = "engine--cursor-crosshair";
    CursorClasses["Default"] = "";
})(CursorClasses || (CursorClasses = {}));
var MouseButtons;
(function (MouseButtons) {
    MouseButtons[MouseButtons["None"] = 0] = "None";
    MouseButtons[MouseButtons["Left"] = 1] = "Left";
    MouseButtons[MouseButtons["Right"] = 2] = "Right";
    MouseButtons[MouseButtons["LeftAndRight"] = 4] = "LeftAndRight";
})(MouseButtons || (MouseButtons = {}));
var maxMouseWheel = 42; // So long, and thanks for all the fish. Don't below 30, it's too slow.
var EngineComponent = /** @class */ (function () {
    function EngineComponent(actions, animationService, cameraService, changeDetecton, engineEventsService, paintService, renderer, store) {
        this.actions = actions;
        this.animationService = animationService;
        this.cameraService = cameraService;
        this.changeDetecton = changeDetecton;
        this.engineEventsService = engineEventsService;
        this.paintService = paintService;
        this.renderer = renderer;
        this.store = store;
        this.flyCamera = true;
        this.chapterActivating = false;
        this.visible = false;
        this.cachedCheckedNodes = [];
        this.cursorClass = CursorClasses.Default;
        this.mouseDelta = null;
        this.ngUnsubscribe = new Subject();
        this.hoveredNode = null;
        this.display = false;
        this.engineVisible = true;
        // Load Progress
        this.assetProgress = 0;
        this.assetTotal = 0;
        this.loading = false;
    }
    Object.defineProperty(EngineComponent.prototype, "isTransparentBackground", {
        get: function () {
            if (this.background) {
                return BackgroundModel.isTransparent(this.background);
            }
            else {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    EngineComponent.prototype.wheel = function (event) {
        this.handleWheel(event);
    };
    EngineComponent.prototype.contextmenu = function (event) {
        this.handleContextMenu(event);
    };
    EngineComponent.prototype.mouseout = function () {
        this.handleMouseOut();
    };
    // map single property state map to graph state map
    EngineComponent.prototype.convertToLeafStateMap = function (property, propertyMap) {
        var leafStateMap = {};
        Object.entries(propertyMap).forEach(function (_a) {
            var _b = __read(_a, 2), id = _b[0], state = _b[1];
            leafStateMap[id] = {};
            leafStateMap[id][property] = state;
        });
        return leafStateMap;
    };
    EngineComponent.prototype.ngOnInit = function () {
        this.bindEngineEvents();
        this.bindApplicationEvents();
        this.bindUserEvents();
        this.bindKeyEvents();
        this.bindHumanInteractions();
        Human.properties.set({ assetDomain: environment.assetDomain });
        Human.workers.setPath('/assets/engine/studio/workers');
        Human.init.init();
    };
    EngineComponent.prototype.ngOnDestroy = function () {
        this.changeDetecton.detach();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    EngineComponent.prototype.initEventListeners = function () {
    };
    EngineComponent.prototype.bindEngineEvents = function () {
        var _this = this;
        // Graph has initialized
        this.engineEventsService.getEvent(EngineEventsEnum.Loaded)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.store.dispatch(new SetReady(true));
        });
        // Chapters have started activating
        this.engineEventsService.getEvent(EngineEventsEnum.TimelineChaptersActivateStart)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.chapterActivating = true;
        });
        // Chapters have finished
        this.engineEventsService.getEvent(EngineEventsEnum.TimelineChaptersActivateFinish)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (params) {
            _this.chapterActivating = false;
            var currentBranch = Human.timeline.activeRoot._nowBranch;
            var chapterInit = {
                id: currentBranch.id,
                init: true,
                camera: currentBranch.initializedCamera,
                annotations: currentBranch.initializedAnnotations,
                graph: currentBranch.initializedGraph,
                properties: currentBranch.initializedProperties,
                particles: currentBranch.initializedParticles,
                clips: currentBranch.initializedClippingPlanes,
                postprocessing: currentBranch.initializedPostprocess,
                transparency: currentBranch.initializedTransparencyMode
            };
            _this.store.dispatch(new SetEngineChapter(params.chapterId));
            _this.store.dispatch(new SetEngineChapterInit(chapterInit));
        });
        // Handle engine tick, but only when it's visible
        this.engineEventsService.getEvent(EngineEventsEnum.Tick)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            if (_this.visible) {
                _this.handleMouseInputEngineTick();
                _this.handleCameraTick();
            }
        });
        // Handle object visibility event
        this.engineEventsService.getEvent(EngineEventsEnum.SceneObjectsShown)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (params) {
            if (!_this.chapterActivating) {
                var stateMap = _this.convertToLeafStateMap('shown', params.enabledObjectsUpdate);
                _this.store.dispatch(new SynchronizeVisibleNodes(stateMap));
            }
        });
        // Handle object renderable event
        this.engineEventsService.getEvent(EngineEventsEnum.SceneObjectRenderable)
            .pipe(bufferTime(1000), takeUntil(this.ngUnsubscribe))
            .subscribe(function (renderable) {
            if (renderable.length) {
                var leafStateMap_1 = {};
                renderable.forEach(function (renderableData) {
                    leafStateMap_1[renderableData.objectId] = { 'renderable': true };
                });
                _this.store.dispatch(new SynchronizeRenderableNodes(leafStateMap_1));
            }
        });
        // Handle asset load
        this.engineEventsService.getEvent(EngineEventsEnum.AssetsLoadStart)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (params) { return _this.loading = true; });
        this.engineEventsService.getEvent(EngineEventsEnum.AssetsLoadProgress)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (result) { return _this.handleLoadProgress(result); });
        this.engineEventsService.getEvent(EngineEventsEnum.AssetsLoadFinish)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (params) { return _this.loading = false; });
    };
    EngineComponent.prototype.bindApplicationEvents = function () {
        var _this = this;
        // Available screen space for the engine has changed
        this.enginePosition$
            .pipe(filter(function (position) { return position != null; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (position) {
            _this.repositionEngine(position);
        });
        this.checkedNodes$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (nodes) {
            _this.paintService.highlightAll(_this.cachedCheckedNodes, false);
            _this.paintService.highlightAll(nodes, true);
            _this.cachedCheckedNodes = __spread(nodes);
        });
        this.actions.pipe(ofActionDispatched(SetCamera), takeUntil(this.ngUnsubscribe)).subscribe(function (action) {
            _this.flyToCamera(action.camera);
        });
        this.actions.pipe(ofActionDispatched(FlyToNode), filter(function (action) { return !!action.node; }), takeUntil(this.ngUnsubscribe)).subscribe(function (action) { return _this.flyToNode(action.node); });
        // New chapter
        this.selectedChapter$
            .pipe(filter(function (chapter) {
            return chapter != null;
        }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (chapter) {
            // set background
            _this.background = _this.store.selectSnapshot(StoryChaptersState.getSelectedChapterBackground);
            Human.timeline.scrub({ chapterId: chapter.id });
        });
        this.background$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (background) {
            _this.background = background;
        });
        // reset cached checked nodes.
        this.selectedChapter$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.cachedCheckedNodes = [];
        });
        // Chapter scene-graph state initialized
        this.chapterInit$
            .pipe(filter(function (chapterInit) { return chapterInit.graph; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            // a new chapter has had its graph updated
            var chapterGraphConfig = _this.engineEventsService.getChapterGraphConfig();
            var viewGraph = _this.engineEventsService.createViewGraph(chapterGraphConfig);
            _this.store.dispatch(new SetGraph(viewGraph));
        });
        // Selected tool changed
        this.activeTool$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (tool) {
            // Reset hover class
            Object.values(CursorClasses).forEach(function (cursorClass) {
                if (cursorClass) {
                    _this.renderer.removeClass(_this.engineElement.nativeElement, cursorClass);
                }
            });
            switch (tool) {
                case ToolEnum.Hide:
                    _this.renderer.addClass(_this.engineElement.nativeElement, CursorClasses.Hide);
                    break;
                case ToolEnum.Label:
                    _this.renderer.addClass(_this.engineElement.nativeElement, CursorClasses.Label);
                    break;
                case ToolEnum.Paint:
                    _this.renderer.addClass(_this.engineElement.nativeElement, CursorClasses.Paint);
                    break;
                case ToolEnum.Isolate:
                case ToolEnum.Fade:
                    _this.renderer.addClass(_this.engineElement.nativeElement, CursorClasses.Crosshair);
                    break;
                default:
                    // Do nothing for now
                    break;
            }
        });
        // Chapter animation
        combineLatest(this.selectedChapter$, this.animationPlaying$)
            .pipe(filter(function (_a) {
            var _b = __read(_a, 1), chapter = _b[0];
            return chapter != null;
        }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (_a) {
            var _b = __read(_a, 2), chapter = _b[0], playing = _b[1];
            var playCount = _.get(chapter, 'ui.play.count') || 0;
            if (_this.animationService.isChapterAnimated(chapter) && chapter.readyState.animation && playing) {
                _this.animationService.play({
                    chapterId: chapter.id,
                    loop: (playCount === -1),
                    queue: false // True for higher playcount
                });
            }
        });
        // display
        this.engineDisplay$.subscribe(function (display) {
            _this.display = display;
            _this.changeDetecton.markForCheck();
        });
        // visibility
        this.engineVisible$.subscribe(function (visible) {
            _this.engineVisible = visible;
            _this.changeDetecton.markForCheck();
        });
    };
    EngineComponent.prototype.bindUserEvents = function () {
        var _this = this;
        // User moves mouse, debounce to small delay so lookup only occurs on pause.
        // Done for performance, doing a node lookup in 3D is expensive.
        this.mouseMove$ = fromEvent(this.engineElement.nativeElement, 'mousemove');
        // Handle all mouse move events, primarily for panning the camera
        this.mouseMove$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (event) {
            _this.handleMousePan(event);
        });
        // User moves mouse, debounce to small delay so  hover lookup only occurs on pause.
        // Done for performance, doing a node lookup in 3D is expensive.
        this.mouseMove$.pipe(debounceTime(10), takeUntil(this.ngUnsubscribe)).subscribe(function (event) {
            _this.handleMouseHover(event);
        });
    };
    EngineComponent.prototype.bindKeyEvents = function () {
        var _this = this;
        var downKeys = ['w', 'a', 's', 'd', 'e', 'c', '=', '-', '+', '_', 'arrowleft', 'arrowright', 'arrowup', 'arrowdown', 'shiftKey']
            .reduce(function (result, value) {
            result[value] = false;
            return result;
        }, {});
        var downKeys$ = new BehaviorSubject(downKeys);
        this.renderer.listen(window, 'keydown', function (event) {
            var _a;
            if (event.repeat || event.metaKey || event.ctrlKey) {
                return;
            }
            // Prevent keyboard events while inputs are focused
            var eventNode = event.target.nodeName.toLowerCase();
            if (['input', 'textarea', 'select', 'option'].indexOf(eventNode) >= 0) {
                return;
            }
            downKeys$.next(__assign({}, downKeys$.value, (_a = {}, _a[event.key.toLowerCase()] = true, _a.shiftKey = event.shiftKey, _a)));
        });
        this.renderer.listen(window, 'keyup', function (event) {
            var _a;
            if (event.key) {
                downKeys$.next(__assign({}, downKeys$.value, (_a = {}, _a[event.key.toLowerCase()] = false, _a.shiftKey = event.shiftKey, _a)));
            }
        });
        downKeys$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (value) {
            var motion = new CameraMotionModel();
            var zoom = value.shiftKey ? KeyboardCamera.ZoomSlow : KeyboardCamera.Zoom;
            var pan = value.shiftKey ? KeyboardCamera.PanSlow : KeyboardCamera.Pan;
            var rotate = value.shiftKey ? KeyboardCamera.RotateSlow : KeyboardCamera.Rotate;
            motion.zoom += (value.c || value['-'] || value['_']) ? zoom : 0;
            motion.zoom -= (value.e || value['='] || value['+']) ? zoom : 0;
            motion.panX -= value.d ? pan : 0;
            motion.panX += value.a ? pan : 0;
            motion.panY += value.w ? pan : 0;
            motion.panY -= value.s ? pan : 0;
            motion.rotateX -= value.arrowright ? rotate : 0;
            motion.rotateX += value.arrowleft ? rotate : 0;
            motion.rotateY += value.arrowup ? rotate : 0;
            motion.rotateY -= value.arrowdown ? rotate : 0;
            _this.store.dispatch(new MoveCamera(motion));
        });
    };
    EngineComponent.prototype.repositionEngine = function (position) {
        this.renderer.setStyle(this.engineElement.nativeElement, 'left', position.left + "px");
        this.renderer.setStyle(this.engineElement.nativeElement, 'top', position.top + "px");
        this.renderer.setStyle(this.engineElement.nativeElement, 'width', position.width + "px");
        this.renderer.setStyle(this.engineElement.nativeElement, 'height', position.height + "px");
        this.renderer.setStyle(this.engineElement.nativeElement, 'zIndex', "" + position.visibility);
        this.renderer.setStyle(this.engineElement.nativeElement, 'visibility', (position.visibility === EngineVisibilityEnum.Shown) ? 'visible' : 'hidden');
        // Engine user interaction will be disabled when the engine isn't visible
        this.visible = position.visibility === EngineVisibilityEnum.Shown;
        Human.renderer.resize();
    };
    /**
     * User Interactions
     * Depends on the HammerJS library to ensure touch compatibility, and manage pan handlers (heh...)
     */
    EngineComponent.prototype.bindHumanInteractions = function () {
        var _this = this;
        // Create a HammerJS manager so we can custom define single and double click
        var mc = new Hammer.Manager(this.engineCanvasElement.nativeElement);
        // Tap recognizer with minimal 2 taps
        mc.add(new Hammer.Tap({ event: 'doubletap', taps: 2 }));
        // Single tap recognizer
        mc.add(new Hammer.Tap({ event: 'singletap' }));
        // Pan recognizer
        mc.add(new Hammer.Pan({ event: 'pan', pointers: 0 }));
        // Ping
        mc.add(new Hammer.Pinch());
        mc.on('singletap', function (event) {
            _this.handleTap(event);
        });
        mc.on('doubletap', function (event) {
            _this.handleDoubleTap(event);
        });
        mc.on('pan', function (event) {
            event.preventDefault();
            _this.handlePan(event);
        });
        var cacheScale = 0;
        mc.on('pinchstart', function (event) {
            cacheScale = event.scale;
        });
        mc.on('pinchmove', function (event) {
            var scale = event.scale - cacheScale;
            Human.renderer.camera.zoom(scale * TouchCamera.Zoom);
            cacheScale = event.scale;
        });
    };
    EngineComponent.prototype.handleMouseHover = function (event) {
        if (event.buttons !== MouseButtons.None) {
            return;
        }
        var offsetX = event.offsetX, offsetY = event.offsetY;
        var hit = Human.renderer.pick.pick(offsetX, offsetY);
        if (hit.objectId) {
            var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
            var hitNode = this.engineEventsService.getNode(viewGraph, hit.objectId);
            var hoveredNode = this.store.selectSnapshot(EngineNodesState.getHoveredNode);
            if (!hoveredNode || hoveredNode.id !== hitNode.id) {
                this.store.dispatch(new HoverNode(hitNode, hit));
            }
        }
        else {
            if (this.store.selectSnapshot(EngineNodesState.getHoveredNode) != null) {
                this.store.dispatch(new HoverNode(null));
            }
        }
    };
    EngineComponent.prototype.handleMousePan = function (event) {
        // Left mouse button is handled by HammerJS 'pan'
        if (event.buttons === 2 || event.buttons === 4) {
            var movementX = event.movementX, movementY = event.movementY;
            movementX /= 10;
            movementY /= 10;
            this.cameraService.setCameraPan(movementX, movementY);
        }
    };
    EngineComponent.prototype.handleMouseOut = function () {
        this.store.dispatch(new HoverNode(null));
    };
    // When it comes to wheel events, we account for both trackpad and scroll wheel. The deltaY
    // from these events can vary wildly between trackpad, mouse type, and browser. Read the docs
    // below to learn more.
    // https://developer.mozilla.org/en-US/docs/Web/API/WheelEvent
    EngineComponent.prototype.handleWheel = function (event) {
        event.preventDefault();
        var deltaY = 0;
        // Check deltaMode, which determines if we're pixel / line / page scrolling
        switch (event.deltaMode) {
            case 0: // Pixel delta (most common, trackpad and mice scroll wheels in Chrome & Safari)
                deltaY = event.deltaY;
                break;
            case 1: // Line delta (less common, mice scroll wheels in Firefox)
                deltaY = event.deltaY * 10;
                break;
            case 2: // Page delta (unlikely)
                deltaY = event.deltaY < 0 ? -40 : 40;
                break;
        }
        // Some mice wheels send a deltaY of 150 or more per click, resulting in massive overzoom.
        // This caps the upper limit of that input.
        if (deltaY > maxMouseWheel) {
            deltaY = maxMouseWheel;
        }
        else if (deltaY < -maxMouseWheel) {
            deltaY = -maxMouseWheel;
        }
        this.cameraService.setCameraZoom(deltaY);
    };
    EngineComponent.prototype.handleContextMenu = function (event) {
        event.preventDefault();
        var offsetX = event.offsetX, offsetY = event.offsetY;
        var hit = this.getHit(offsetX, offsetY);
        var node = this.getNodeFromHit(hit);
    };
    EngineComponent.prototype.handleTap = function (event) {
        var _a = this.getOffset(event), offsetX = _a.offsetX, offsetY = _a.offsetY;
        var hit = this.getHit(offsetX, offsetY);
        var node = this.getNodeFromHit(hit);
        this.store.dispatch(new ClickNode(node, event, hit));
    };
    EngineComponent.prototype.handleDoubleTap = function (event) {
        var _a = this.getOffset(event), offsetX = _a.offsetX, offsetY = _a.offsetY;
        var hit = this.getHit(offsetX, offsetY);
        var node = this.getNodeFromHit(hit);
        this.store.dispatch(new FlyToNode(node));
    };
    EngineComponent.prototype.handlePan = function (event) {
        var panMode = this.store.selectSnapshot(EngineCameraState.getPanMode);
        if (event.srcEvent.shiftKey || panMode === 'pan') {
            this.cameraService.setCameraPan(event.velocityX, event.velocityY * 1.5);
        }
        else {
            this.cameraService.setCameraRotation(event.velocityX, event.velocityY * 1.5);
        }
    };
    EngineComponent.prototype.handleMouseInputEngineTick = function () {
        var rotation = this.cameraService.tickCameraRotation();
        var pan = this.cameraService.tickCameraPan();
        var zoom = this.cameraService.tickCameraZoom();
        // Rotation
        if (rotation.vx !== 0) {
            Human.renderer.camera.rotateX(rotation.vx * MouseCamera.Rotate);
        }
        if (rotation.vy !== 0) {
            Human.renderer.camera.rotateY(rotation.vy * MouseCamera.Rotate);
        }
        // Pan
        if (pan.x || pan.y) {
            var f = Math.max(Human.renderer.camera.lookDistance / 80, 0.01);
            Human.renderer.camera.pan({
                x: (pan.x * f) * MouseCamera.Pan,
                y: (pan.y * f) * MouseCamera.Pan
            });
        }
        // Zoom
        if (zoom !== 0) {
            Human.renderer.camera.zoom(zoom * MouseCamera.Zoom);
        }
    };
    EngineComponent.prototype.handleCameraTick = function () {
        var motion = this.store.selectSnapshot(EngineCameraState.getCameraMotion);
        // PAN
        this.cameraService.setCameraPan(motion.panX, motion.panY);
        this.cameraService.setCameraRotation(motion.rotateX, motion.rotateY);
        this.cameraService.setCameraZoom(motion.zoom);
    };
    EngineComponent.prototype.handleLoadProgress = function (progress) {
        this.assetProgress = progress.receivedAssets;
        this.assetTotal = progress.requestedAssets;
        this.loading = progress.receivedAssets === progress.receivedAssets;
        this.changeDetecton.markForCheck();
    };
    EngineComponent.prototype.flyToNode = function (node) {
        var humanObjectIds = this.engineEventsService.getLeaves(node.id);
        var boundary = this.engineEventsService.getBoundaryFromObjects(humanObjectIds);
        Human.renderer.camera.fly.flyTo({
            boundary: boundary
        });
    };
    EngineComponent.prototype.flyToCamera = function (camera) {
        Human.renderer.camera.fly.flyTo(camera);
    };
    EngineComponent.prototype.getNodeFromHit = function (hit) {
        var node;
        if (hit.objectId) {
            var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
            node = this.engineEventsService.getNode(viewGraph, hit.objectId);
        }
        return node;
    };
    EngineComponent.prototype.getHit = function (x, y) {
        // For clicks, set rayPick to true so we get a completely detailed hit object
        // that includes the exact triangle the user clicked on. This is different 
        // from hover, that only target the general node. 
        var hit = Human.renderer.pick.pick(x, y, { rayPick: true });
        return hit;
    };
    EngineComponent.prototype.getContainerStyles = function () {
        var styles = {};
        // set background
        if (this.background && !this.isTransparentBackground) {
            styles['background-image'] = BackgroundModel.toCSS(this.background);
        }
        // set display
        if (!this.display) {
            styles['display'] = 'none';
        }
        // set transparent
        if (!this.engineVisible) {
            styles['opacity'] = 0;
        }
        return styles;
    };
    // We calculate offsetX and offsetY using rect and center because iOS safari
    // does not natively support offsetX and offsetY. Those properties return `undefined`
    // when requested. 
    // More: http://www.jacklmoore.com/notes/mouse-position/
    EngineComponent.prototype.getOffset = function (event) {
        var x = 0;
        var y = 0;
        if (event.center) {
            x = event.center.x;
            y = event.center.y;
        }
        else {
            x = event.clientX;
            y = event.clientY;
        }
        var target = this.engineElement.nativeElement;
        var rect = target.getBoundingClientRect();
        return {
            offsetX: x - rect.left,
            offsetY: y - rect.top
        };
    };
    __decorate([
        Select(EngineState.getReady),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "ready$", void 0);
    __decorate([
        Select(EngineState.getViewGraph),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "viewGraph$", void 0);
    __decorate([
        Select(EngineState.getEnginePosition),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "enginePosition$", void 0);
    __decorate([
        Select(EngineNodesState.getHoveredNode),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "hoveredNode$", void 0);
    __decorate([
        Select(EngineState.getChapter),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "chapter$", void 0);
    __decorate([
        Select(EngineState.getChapterInit),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "chapterInit$", void 0);
    __decorate([
        Select(EngineNodesState.getSelectedNode),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "selectedNode$", void 0);
    __decorate([
        Select(EngineNodesState.getCheckedNodes),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "checkedNodes$", void 0);
    __decorate([
        Select(EngineState.getActiveTool),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "activeTool$", void 0);
    __decorate([
        Select(EngineState.getAnimationPlaying),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "animationPlaying$", void 0);
    __decorate([
        Select(EngineState.getDisplay),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "engineDisplay$", void 0);
    __decorate([
        Select(EngineState.getVisible),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "engineVisible$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "selectedChapter$", void 0);
    __decorate([
        Select(EngineCameraState.getCameraMotion),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "cameraMotion$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterBackground),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "background$", void 0);
    return EngineComponent;
}());
export { EngineComponent };
